import { SKIP_CHANNEL_DETAILS_FAILURE, SKIP_CHANNEL_DETAILS_REQUEST, SKIP_CHANNEL_DETAILS_SUCCESS } from "../../actions";
const initialState = {
    result: null,
    data: null,
    loading: false,
    error: null,
};
const skipChannelReducer = (state = initialState, action) => {
    switch (action.type) {
        case SKIP_CHANNEL_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case SKIP_CHANNEL_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case SKIP_CHANNEL_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default skipChannelReducer;
